import { useEffect, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Box, MenuItem,
    Typography,
    Paper, Divider,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    CircularProgress,
    TextField,
    Grid
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getAllCardForCustomTab } from "../../../services/hospital.service";
import { DEFAULT_CARD_FILTER } from "../../../store/reducers/hospital.slice";
import { DEFAULT_CARD_FILTER as DEFAULT_CARD_FILTER_ADMISSION } from "../../../store/reducers/admission.slice";
import { updateFilterListData } from "../../../utilis/hospital-common";
import { updateFilterListData as updateFilterListDataCommunity } from "../../../utilis/community-common";
import { updateFilterListData as updateFilterListDataDeceased } from "../../../utilis/deceased-common";
import { updateFilterListData as updateFilterListDataOverall } from "../../../utilis/overall-common";
import { DEFAULT_COMMUNITY_DATA } from "../../../store/reducers/community-transfer.slice";
import { getAllCardForCommunity } from "../../../services/community-transfer.service";
import { getAllCardForDeceased } from "../../../services/deceased.service";
import { DEFAULT_DECEASED_DATA } from "../../../store/reducers/deceased.slice";
import { getAllCardForAdmissions } from "../../../services/admission.service";
import { updateFilterListDataBoth } from "../../../utilis/admission-common";
import { HOSPITAL_CARDS_LABELS, HOSPITAL_CARDS_TYPE } from "../../../types/hospital.type";
import { ADMISSION_CARDS_LABELS, ADMISSION_CARDS_TYPE } from "../../../types/admission.type";
import { CO_TRANSFER_CARDS_TYPE, COMMUNITY_CARD_LABELS } from "../../../types/community-transfer.type";
import { DECEASED_CARDS_LABELS, DECEASED_CARDS_TYPE } from "../../../types/deceased.type";
import { createCustomTab, getDynamicDataTabById } from "../../../services/custom-tab.service";
import { useDispatch } from "react-redux";
import { ADD_NOTIFICATION } from "../../../store/types";
import { getQuestionsData } from "../../../services/dynamic-data-tab.service";
import { ADT_SUB_TYPES, CUSTOM_TAB_TYPE } from "../../../types/common.type";
import { setIsCustomTabAdded } from "../../../store/reducers/common.slice";
import ErrorPopover from '../custom-popover/ErrorPopover';
import LabeledSelect from './LabeledSelect';
import LabeledTextField from './LabeledTextField';
import LabeledTextarea from './LabeledTextarea';
import LoadingBlock from './LoadingBlock';
import DialogActionsRow from './DialogActionsRow';
import ItemAutocomplete from "./ItemAutocomplete";
import { selectedTabAccess } from "../../../utilis/common";
import { DEFAULT_OVERALL_DATA } from "../../../store/reducers/overall.slice";
import { getAllOverallPatient } from "../../../services/overall.service";
import { OVERALL_CARDS_LABELS, OVERALL_CARDS_TYPE } from "../../../types/overall.type";
import { CUSTOM_TAB_PAGE_TYPE } from "../../../types/pages.type";
import { PAGE_TYPE } from "../../../types/pages.type";
import aiService from "../../../services/api/ai.service";



const validPageTypes = Object.entries(CUSTOM_TAB_PAGE_TYPE).filter(
    ([key]) => key !== "ADT"
);

const CARD_CONFIG = {
    [CUSTOM_TAB_PAGE_TYPE.HOSPITAL]: [
        { value: HOSPITAL_CARDS_TYPE.TOTAL, label: HOSPITAL_CARDS_LABELS.total },
        { value: HOSPITAL_CARDS_TYPE.UNPLANNED, label: HOSPITAL_CARDS_LABELS.unplannedHospitalTransfer },
        { value: HOSPITAL_CARDS_TYPE.PLANNED, label: HOSPITAL_CARDS_LABELS.plannedHospitalTransfer },
    ],
    [CUSTOM_TAB_PAGE_TYPE.COMMUNITY_TRANSFER]: [
        { value: CO_TRANSFER_CARDS_TYPE.TOTAL, label: COMMUNITY_CARD_LABELS.total },
        { value: CO_TRANSFER_CARDS_TYPE.AMA, label: COMMUNITY_CARD_LABELS.AMA },
        { value: CO_TRANSFER_CARDS_TYPE.SNF, label: COMMUNITY_CARD_LABELS.SNF },
        { value: CO_TRANSFER_CARDS_TYPE.SAFE_DISCHARGE, label: COMMUNITY_CARD_LABELS.safeDischarge },
    ],
    [CUSTOM_TAB_PAGE_TYPE.DECEASED]: [
        { value: DECEASED_CARDS_TYPE.TOTAL, label: DECEASED_CARDS_LABELS.total },
    ],
    [CUSTOM_TAB_PAGE_TYPE.OVERALL_INCOMING]: [
        { value: OVERALL_CARDS_TYPE.TOTAL_INCOMING, label: OVERALL_CARDS_LABELS.totalIncoming },
    ],
    [CUSTOM_TAB_PAGE_TYPE.OVERALL_OUTGOING]: [
        { value: OVERALL_CARDS_TYPE.TOTAL_OUTGOING, label: OVERALL_CARDS_LABELS.totalOutgoing },
        { value: OVERALL_CARDS_TYPE.EXHUAST_INSURANCE_DATA, label: "Medicare Exhaust" },
        { value: OVERALL_CARDS_TYPE.EXHUST_AVARAGE_DATA, label: OVERALL_CARDS_LABELS.exhaustAverageData },
    ],
    [CUSTOM_TAB_PAGE_TYPE.ADMISSION]: [
        { value: ADMISSION_CARDS_TYPE.TOTAL, label: ADMISSION_CARDS_LABELS.total },
        { value: ADMISSION_CARDS_TYPE.ADMISSION, label: ADMISSION_CARDS_LABELS.admission },
        { value: ADMISSION_CARDS_TYPE.READMISSION, label: ADMISSION_CARDS_LABELS.readmission },
    ],
};

const PAGE_CONFIG = {
    [CUSTOM_TAB_PAGE_TYPE.HOSPITAL]: {
        cardFilter: DEFAULT_CARD_FILTER,
        getCards: getAllCardForCustomTab,
        updateFn: updateFilterListData,
        query: {
            forType: "transfer",
            forTransferType: ["hospitalTransfer"],
            isCustom: true,
        },
    },
    [CUSTOM_TAB_PAGE_TYPE.COMMUNITY_TRANSFER]: {
        cardFilter: DEFAULT_COMMUNITY_DATA,
        getCards: getAllCardForCommunity,
        updateFn: updateFilterListDataCommunity,
        query: {
            forType: "transfer",
            forTransferType: [ADT_SUB_TYPES.AMA, ADT_SUB_TYPES.SAFE_DISCHARGE, ADT_SUB_TYPES.SNF, ADT_SUB_TYPES.TOTAL_COMMUNITY],
            isCustom: true,
        },
    },
    [CUSTOM_TAB_PAGE_TYPE.DECEASED]: {
        cardFilter: DEFAULT_DECEASED_DATA,
        getCards: getAllCardForDeceased,
        updateFn: updateFilterListDataDeceased,
        query: {
            forType: "transfer",
            forTransferType: ["deceased"],
            isCustom: true,
        },
    },
    [CUSTOM_TAB_PAGE_TYPE.ADMISSION]: {
        cardFilter: DEFAULT_CARD_FILTER_ADMISSION,
        getCards: getAllCardForAdmissions,
        updateFn: updateFilterListDataBoth,
        query: {
            isCustom: true,
        },
    },
    [CUSTOM_TAB_PAGE_TYPE.OVERALL_INCOMING]: {
        cardFilter: DEFAULT_OVERALL_DATA,
        getCards: getAllOverallPatient,
        updateFn: updateFilterListDataOverall,
        query: {
            isCustom: true,
        },
    },
    [CUSTOM_TAB_PAGE_TYPE.OVERALL_OUTGOING]: {
        cardFilter: DEFAULT_OVERALL_DATA,
        getCards: getAllOverallPatient,
        updateFn: updateFilterListDataOverall,
        query: {
            isCustom: true,
        },
    },
};

const LABEL_MAP = {
    [CUSTOM_TAB_PAGE_TYPE.ADMISSION]: ADMISSION_CARDS_LABELS,
    [CUSTOM_TAB_PAGE_TYPE.COMMUNITY_TRANSFER]: COMMUNITY_CARD_LABELS,
    [CUSTOM_TAB_PAGE_TYPE.DECEASED]: DECEASED_CARDS_LABELS,
    [CUSTOM_TAB_PAGE_TYPE.HOSPITAL]: HOSPITAL_CARDS_LABELS,
    [CUSTOM_TAB_PAGE_TYPE.OVERALL_INCOMING]: OVERALL_CARDS_LABELS,
    [CUSTOM_TAB_PAGE_TYPE.OVERALL_OUTGOING]: OVERALL_CARDS_LABELS,
};

const AddCombineTabDialog = ({ handleClose, filter, page, id = null, isCreator: isCreatorProp = true, existingTabOptions = [] }) => {
    const selectedTab = selectedTabAccess();

    const isEditMode = Boolean(id);
    const [dataPointCount, setDataPointCount] = useState(1);
    const [inputValues, setInputValues] = useState([""]);
    const [dataPointLabels, setDataPointLabels] = useState([""]); // Labels for each data point
    const [cardItemData, setCardItemData] = useState([]);
    const [selectedCardItems, setSelectedCardItems] = useState([
        {
            filters: [
                {
                    card: { value: "", label: "", questionId: null },
                    items: [],
                    isMainCard: false
                }
            ],
            dashboard: ""
        }
    ]);
    const [operations, setOperations] = useState([]);
    const [cachedData, setCachedData] = useState({});
    const [errorPopover, setErrorPopover] = useState({ open: false, message: "" });
    const dispatch = useDispatch();
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [errorMessages, setErrorMessages] = useState([]);
    const [fieldErrors, setFieldErrors] = useState({
        title: false,
        dataPoints: [], // For each data point
        customDateRanges: [], // For custom date ranges validation
        customTimeRanges: [], // For custom time ranges validation
    });
    const [isSaving, setIsSaving] = useState(false);
    const [titleError, setTitleError] = useState(false);
    const [isCreator, setIsCreator] = useState(isCreatorProp);
    const [initialLoading, setInitialLoading] = useState(isEditMode);

    // AI Description states
    const [isVerifyingAI, setIsVerifyingAI] = useState(false);
    const [aiDescription, setAiDescription] = useState("");
    const [aiDescriptionError, setAiDescriptionError] = useState(null);

    // Custom Date/Time Analysis states
    const [showCustomDateAnalysisDialog, setShowCustomDateAnalysisDialog] = useState(false);
    const [isCustomDateAnalysis, setIsCustomDateAnalysis] = useState(false);
    const [customDateRanges, setCustomDateRanges] = useState([{ minDays: 0, maxDays: 5 }]);
    const [customAnalysisType, setCustomAnalysisType] = useState("date"); // "date" or "time"
    const [customTimeRanges, setCustomTimeRanges] = useState([{ label: '', startTime: '', endTime: '' }]);

    // Exhaust Average Data states (similar to 90-day analysis)
    const [showExhaustAverageDialog, setShowExhaustAverageDialog] = useState(false);
    // Note: exhaustAverageRanges uses customDateRanges state (same as 90-day analysis)

    useEffect(() => {
        if (isEditMode) {
            setInitialLoading(true);
            const fetchTabData = async () => {
                try {
                    const response = await getDynamicDataTabById(id);
                    const tabData = response;

                    if (tabData) {
                        setIsCreator(isCreatorProp);

                        setTitle(tabData.title || "");
                        setDescription(tabData.description || "");
                        setAiDescription(tabData.aiDescription || ""); // Load AI description if exists

                        const filters = tabData.filters || [];
                        const filterCount = filters.length || 1;
                        setDataPointCount(filterCount);

                        // Initialize arrays with proper length
                        const inputValuesEdit = new Array(filterCount).fill("");
                        const dataPointLabelsEdit = new Array(filterCount).fill("");
                        const newCachedData = {};
                        const pendingFilters = new Array(filterCount);
                        const pendingCardItemData = new Array(filterCount);

                        // First, fetch all card data
                        await Promise.all(
                            filters.map(async (filterGroup, index) => {
                                const dashboard = filterGroup.dashboard;
                                inputValuesEdit[index] = dashboard;
                                // Set label: use saved label from filterGroup.label if exists, 
                                // or check old dataPointLabels array for backward compatibility, 
                                // otherwise default to data point name
                                if (filterGroup.label && filterGroup.label.trim()) {
                                    dataPointLabelsEdit[index] = filterGroup.label;
                                } else if (tabData.dataPointLabels &&
                                    Array.isArray(tabData.dataPointLabels) &&
                                    tabData.dataPointLabels[index] &&
                                    tabData.dataPointLabels[index].trim()) {
                                    // Backward compatibility: check old dataPointLabels array
                                    dataPointLabelsEdit[index] = tabData.dataPointLabels[index];
                                } else {
                                    // Default to formatted data point name
                                    dataPointLabelsEdit[index] = dashboard ? formatDataPointName(dashboard) : "";
                                }

                                let result = cachedData[dashboard];
                                if (!result) {
                                    result = await fetchCardAndItemOptions(dashboard);
                                    newCachedData[dashboard] = result;
                                }

                                pendingCardItemData[index] = { loading: false, ...result };

                                const filtersArray = (filterGroup.filters || []).map((filter, filterIndex) => {
                                    if (!filter.card?.value && filter.card?.label) {
                                        filter.card.value = filter.card.label;
                                    }

                                    return {
                                        card: filter.card,
                                        items: filter.items || [],
                                        isMainCard:
                                            index === filters.length - 1 &&
                                            filterIndex === (filterGroup.filters.length - 1),
                                    };
                                });

                                pendingFilters[index] = {
                                    dashboard,
                                    filters: filtersArray,
                                };
                            })
                        );

                        // Set all states at once to avoid race conditions
                        setInputValues(inputValuesEdit);
                        setDataPointLabels(dataPointLabelsEdit);
                        setCardItemData(pendingCardItemData);
                        setSelectedCardItems(pendingFilters);
                        setCachedData((prevCache) => ({ ...prevCache, ...newCachedData }));

                        // Load operations if they exist (for combine tabs with operations)
                        if (tabData.operations && Array.isArray(tabData.operations)) {
                            setOperations(tabData.operations);
                        } else {
                            // Initialize with 'plus' operations if not set
                            setOperations(new Array(Math.max(0, filterCount - 1)).fill('plus'));
                        }

                        // Load custom date/time analysis state if it exists
                        const isCustomDateAnalysisEdit = tabData.isCustomDateAnalysis || false;
                        const customAnalysisTypeEdit = tabData.customAnalysisType || "date";

                        if (isCustomDateAnalysisEdit) {
                            setIsCustomDateAnalysis(true);
                            // Set custom analysis type (default to "date" for backward compatibility)
                            setCustomAnalysisType(customAnalysisTypeEdit);

                            if (customAnalysisTypeEdit === "time") {
                                // Load time ranges
                                if (tabData.customDateRanges && Array.isArray(tabData.customDateRanges)) {
                                    setCustomTimeRanges(tabData.customDateRanges);
                                }
                            } else {
                                // Load date ranges (default) - includes both ranges and averages
                                if (tabData.customDateRanges && Array.isArray(tabData.customDateRanges)) {
                                    setCustomDateRanges(tabData.customDateRanges);
                                }
                            }

                            // Recalculate isMainCard flags based on custom date analysis mode
                            pendingFilters.forEach((dp, dpIndex) => {
                                if (!dp) return;
                                dp.filters = dp.filters.map((filter, filterIndex) => {
                                    let shouldBeMainCard = false;

                                    if (filter.card?.value) {
                                        if (customAnalysisTypeEdit === "date") {
                                            const isDateCard = filter.card.value === "ninetyDaysData" ||
                                                filter.card.value === "sixtyDaysData" ||
                                                filter.card.customQuestionInputType === "dateAnalysis";
                                            shouldBeMainCard = isDateCard;
                                        } else if (customAnalysisTypeEdit === "time") {
                                            const isTimeCard = filter.card.value === "shiftData" ||
                                                filter.card.customQuestionInputType === "timeTabRange";
                                            shouldBeMainCard = isTimeCard;
                                        }
                                    }

                                    return { ...filter, isMainCard: shouldBeMainCard };
                                });
                            });
                        }

                        // Load exhaust average ranges from customDateRanges (same as 90-day analysis)
                        // Check if exhaustAverageData card is selected
                        const hasExhaustAverageCard = pendingFilters.some((dp) =>
                            dp?.filters?.some(filter => filter?.card?.value === OVERALL_CARDS_TYPE.EXHUST_AVARAGE_DATA)
                        );
                        if (hasExhaustAverageCard && !isCustomDateAnalysisEdit && tabData.customDateRanges && Array.isArray(tabData.customDateRanges) && tabData.customDateRanges.length > 0) {
                            setCustomDateRanges(tabData.customDateRanges);
                        }
                    } else {
                        setIsCreator(isCreatorProp);
                    }
                } catch (err) {
                    console.error("Failed to fetch tab data", err);
                } finally {
                    setInitialLoading(false);
                }
            };

            fetchTabData();
        } else {
            setInitialLoading(false);
            // Initialize with default operations for new tabs
            setOperations([]);
        }
    }, [id, isCreatorProp]); // eslint-disable-line react-hooks/exhaustive-deps

    // Ensure cardItemData array length matches dataPointCount
    useEffect(() => {
        if (cardItemData.length !== dataPointCount) {
            setCardItemData((prev) => {
                const updated = [...prev];
                if (dataPointCount > prev.length) {
                    // Add missing elements
                    for (let i = prev.length; i < dataPointCount; i++) {
                        updated[i] = { loading: false, cards: [], items: [] };
                    }
                } else {
                    // Remove extra elements
                    updated.splice(dataPointCount);
                }
                return updated;
            });
        }
    }, [dataPointCount, cardItemData.length]);

    // Ensure cardItemData is loaded for all selected dashboards
    useEffect(() => {
        const loadMissingData = async () => {
            const promises = [];

            selectedCardItems.forEach((item, index) => {
                if (item?.dashboard && !cardItemData[index]?.cards?.length && !cardItemData[index]?.loading) {
                    promises.push(
                        (async () => {
                            setCardItemData((prev) => {
                                const updated = [...prev];
                                updated[index] = { ...updated[index], loading: true };
                                return updated;
                            });

                            const result = await fetchCardAndItemOptions(item.dashboard);
                            setCachedData((prevCache) => ({ ...prevCache, [item.dashboard]: result }));

                            setCardItemData((prev) => {
                                const updated = [...prev];
                                updated[index] = { loading: false, ...result };
                                return updated;
                            });
                        })()
                    );
                }
            });

            if (promises.length > 0) {
                await Promise.all(promises);
            }
        };

        if (selectedCardItems.length > 0) {
            loadMissingData();
        }
    }, [selectedCardItems.map(item => item?.dashboard).join(',')]); // eslint-disable-line react-hooks/exhaustive-deps

    async function fetchCardAndItemOptions(dataPoint) {
        const cards = [];
        const items = [];

        const config = PAGE_CONFIG[dataPoint];
        if (!config) return { cards, items };

        const updatedFilter = {
            ...filter,
            isSkipCustomCard: true,
            ...(filter?.startDate && filter?.endDate
                ? {
                    // startDate: moment(filter.endDate).subtract(30, "days").toDate(),
                    startDate: filter.startDate,
                    endDate: filter.endDate,
                }
                : {}),
        };

        const res = await config.getCards(updatedFilter);

        const query = { page, ...config.query };
        const dynamicCardsData = await getQuestionsData(query);
        const dynamicCardsDataArr = dynamicCardsData?.filter(item => (!item.isDefaultCard)) ?? [];
        const dynamicCards = dynamicCardsDataArr?.filter(item => (!item.existingAccessor)) ?? [];

        const labelMap = LABEL_MAP[dataPoint] ?? {};
        const cardFilter = config.cardFilter;

        let result;

        if (dataPoint === CUSTOM_TAB_PAGE_TYPE.ADMISSION) {
            result = await config.updateFn(
                { ...res?.data, dynamicCards },
                cardFilter,
                null,
                cardFilter?.mainPriorityData,
                [],
                false
            );

            if (result?.patientList?.averageStayDaysData) {
                delete result.patientList.averageStayDaysData;
            }
        } else if (dataPoint === CUSTOM_TAB_PAGE_TYPE.HOSPITAL) {
            result = await config.updateFn(
                cardFilter,
                null,
                { ...res, dynamicCards },
                cardFilter?.priorityData,
                false,
                res?.defaultCardShiftData ? [res?.defaultCardShiftData] : []
            );
        } else if (dataPoint === CUSTOM_TAB_PAGE_TYPE.OVERALL_INCOMING || dataPoint === CUSTOM_TAB_PAGE_TYPE.OVERALL_OUTGOING) {
            result = await config.updateFn(
                cardFilter,
                { ...res, dynamicCards },
                cardFilter?.priorityData,
                [],
                false
            );
        } else {
            result = await config.updateFn(
                cardFilter,
                { ...res?.data, dynamicCards },
                cardFilter?.priorityData,
                [],
                false
            );
        }
        const latestListData = dataPoint === CUSTOM_TAB_PAGE_TYPE.ADMISSION ? result?.patientList : result;

        if (!latestListData) return { cards, items };

        for (const [key, value] of Object.entries(latestListData)) {
            if (key === "pageConverterFilteredPatients") continue;
            if (!Array.isArray(value) || /_?customtab/i.test(key)) continue;

            const dynamicCard = dynamicCards.find(dc => dc.accessor === key);
            const label = dynamicCard?.label ?? dynamicCard?.tableLabel ?? labelMap[key] ?? key;

            if (dataPoint === CUSTOM_TAB_PAGE_TYPE.OVERALL_INCOMING && key === OVERALL_CARDS_TYPE.NINETY_DAYS_DATA) continue;
            if ((dataPoint === CUSTOM_TAB_PAGE_TYPE.OVERALL_INCOMING || dataPoint === CUSTOM_TAB_PAGE_TYPE.OVERALL_OUTGOING) && key === OVERALL_CARDS_TYPE.EXHUAST_INSURANCE_DATA) continue;
            cards.push({
                value: key,
                label,
                questionId: dynamicCard?._id ?? null,
                dataPoint,
                accessor: dynamicCard?.accessor ?? null,
                customQuestionInputType: dynamicCard?.customQuestionInputType ?? null,
            });

            for (const ele of value) {
                if (ele?.isSpacialItem) continue;

                items.push({
                    value: ele._id,
                    label: ele?.label ?? ele?.name ?? ele?.title,
                    parentId: key,
                    questionId: dynamicCard?._id ?? null
                });
            }
        }

        if (CARD_CONFIG[dataPoint]) {
            const staticCards = CARD_CONFIG[dataPoint].map(card => ({
                ...card,
                questionId: null,
                dataPoint,
                isTotalCard: true,
            }));
            // Keep predefined cards (from CARD_CONFIG) at the top of Select Card options.
            cards.unshift(...staticCards);
        }
        return { cards, items };
    }

    // Helper function to format data point name for default label
    const formatDataPointName = (dataPointValue) => {
        if (!dataPointValue) return "";
        // Find the label from validPageTypes
        const pageTypeEntry = validPageTypes.find(([_, value]) => value === dataPointValue);
        if (pageTypeEntry) {
            const [label] = pageTypeEntry;
            const cleanedLabel = label.replace(/_/g, " ");
            return (
                cleanedLabel.charAt(0).toUpperCase() +
                cleanedLabel.slice(1).toLowerCase()
            );
        }
        // Fallback: format the value itself
        return dataPointValue
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    };

    const handleCountChange = (e) => {
        const value = e.target.value;

        // Allow clearing the input (intermediate empty state)
        if (value === "") {
            setDataPointCount("");
            return;
        }

        const newCount = parseInt(value);
        if (isNaN(newCount) || newCount < 0) return;

        setDataPointCount(newCount);

        setInputValues((prev) =>
            newCount > prev.length ? [...prev, ...Array(newCount - prev.length).fill("")] : prev.slice(0, newCount)
        );

        setDataPointLabels((prev) => {
            const updated = [...prev];
            if (newCount > prev.length) {
                // Add labels for new data points - set default if data point already has value
                for (let i = prev.length; i < newCount; i++) {
                    const dataPointValue = inputValues[i];
                    updated[i] = dataPointValue ? formatDataPointName(dataPointValue) : "";
                }
            } else {
                // Remove excess labels
                updated.splice(newCount);
            }
            return updated;
        });

        setCardItemData((prev) =>
            newCount > prev.length
                ? [...prev, ...Array(newCount - prev.length).fill({ loading: false, cards: [], items: [] })]
                : prev.slice(0, newCount)
        );

        setSelectedCardItems((prev) =>
            newCount > prev.length
                ? [...prev, ...Array(newCount - prev.length).fill({
                    filters: [{ card: { value: "", label: "", questionId: null }, items: [], isMainCard: false }],
                    dashboard: ""
                })]
                : prev.slice(0, newCount)
        );

        // Update operations array - should have (newCount - 1) operations between data points
        setOperations((prev) => {
            const operationsNeeded = Math.max(0, newCount - 1);
            if (operationsNeeded > prev.length) {
                // Add more operations (default to 'plus')
                return [...prev, ...Array(operationsNeeded - prev.length).fill('plus')];
            } else {
                // Remove excess operations
                return prev.slice(0, operationsNeeded);
            }
        });
    };

    const handleInputChange = async (index, value) => {
        // Update input values
        const updatedInputs = [...inputValues];
        updatedInputs[index] = value;

        setInputValues(updatedInputs);

        // Update label with default data point name if label is empty or was the previous default
        setDataPointLabels((prev) => {
            const updated = [...prev];
            const previousValue = inputValues[index];
            const previousDefaultLabel = previousValue ? formatDataPointName(previousValue) : "";
            // If data point is cleared, clear the label
            if (!value) {
                updated[index] = "";
            } else if (!updated[index] || updated[index] === previousDefaultLabel) {
                // If current label is empty or matches previous default, set new default
                updated[index] = formatDataPointName(value);
            }
            return updated;
        });

        // Reset the selected filters for this data point because the page type has changed
        setSelectedCardItems((prev) => {
            const updated = [...prev];
            updated[index] = {
                filters: [{ items: [], card: { value: "", label: "", questionId: null }, isMainCard: false }],
                dashboard: value,
            };
            return updated;
        });

        // Use cached if exists
        if (cachedData[value]) {
            setCardItemData((prev) => {
                const updated = [...prev];
                updated[index] = { loading: false, ...cachedData[value] };
                return updated;
            });
            return;
        }

        // Set loading while fetching
        setCardItemData((prev) => {
            const updated = [...prev];
            updated[index] = { loading: true, cards: [], items: [] };
            return updated;
        });

        // Fetch and set new data
        const result = await fetchCardAndItemOptions(value);
        setCachedData((prevCache) => ({ ...prevCache, [value]: result }));

        setCardItemData((prev) => {
            const updated = [...prev];
            updated[index] = { loading: false, ...result };
            return updated;
        });
    };

    // Store pending card selection for custom date analysis confirmation
    const [pendingCardSelection, setPendingCardSelection] = useState(null);
    // Store pending card selection for exhaust average confirmation
    const [pendingExhaustAverageSelection, setPendingExhaustAverageSelection] = useState(null);

    const handleCardItemChange = (dpIndex, filterIndex, field, value, isMainCard = false, questionId = null) => {
        // Check if this is an exhaust average card selection
        if (field === "card" && value?.value === OVERALL_CARDS_TYPE.EXHUST_AVARAGE_DATA) {
            // Show confirmation dialog and store pending selection
            setPendingExhaustAverageSelection({ dpIndex, filterIndex, value, isMainCard });
            setShowExhaustAverageDialog(true);
            return; // Don't update yet, wait for user confirmation
        }

        // Check if this is a date/time analysis card selection and we're not already in custom analysis mode
        if (field === "card" && !isCustomDateAnalysis) {
            const isDateCard = value?.value === "ninetyDaysData" || value?.value === "sixtyDaysData" || value?.customQuestionInputType === "dateAnalysis";
            const isTimeCard = value?.value === "shiftData" || value?.customQuestionInputType === "timeTabRange";

            if (isDateCard || isTimeCard) {
                // Set analysis type based on card type
                if (isDateCard) {
                    setCustomAnalysisType("date");
                } else if (isTimeCard) {
                    setCustomAnalysisType("time");
                }
                // Show confirmation dialog and store pending selection
                setPendingCardSelection({ dpIndex, filterIndex, value, isMainCard });
                setShowCustomDateAnalysisDialog(true);
                return; // Don't update yet, wait for user confirmation
            }
        }

        setSelectedCardItems((prev) => {
            const updated = [...prev];

            // Ensure the data point exists
            const existingDataPoint = updated[dpIndex] || {
                filters: [],
                dashboard: inputValues[dpIndex],
                questionId,
            };

            // Ensure filters array is properly cloned
            const filters = [...(existingDataPoint.filters || [])];

            // Ensure the filter at filterIndex exists with safe defaults
            filters[filterIndex] = filters[filterIndex] || {
                card: { value: "", label: "", questionId: null },
                items: [],
                isMainCard,
            };

            if (field === "card") {
                // If isCustomDateAnalysis is true, only date/time cards (matching customAnalysisType) should be isMainCard
                // Otherwise, use the default isMainCard logic (last filter of last data point)
                let shouldBeMainCard = isMainCard;
                if (isCustomDateAnalysis) {
                    if (customAnalysisType === "date") {
                        const isDateCard = value?.value === "ninetyDaysData" || value?.value === "sixtyDaysData" || value?.customQuestionInputType === "dateAnalysis";
                        shouldBeMainCard = isDateCard ? true : false;
                    } else if (customAnalysisType === "time") {
                        const isTimeCard = value?.value === "shiftData" || value?.customQuestionInputType === "timeTabRange";
                        shouldBeMainCard = isTimeCard ? true : false;
                    }
                }

                filters[filterIndex] = {
                    ...filters[filterIndex],
                    card: value,
                    items: [], // Reset items when changing card
                    isMainCard: shouldBeMainCard,
                };
            } else if (field === "items") {
                filters[filterIndex] = {
                    ...filters[filterIndex],
                    items: value,
                    isMainCard,
                };
            }

            // Assign the updated filters back to the data point
            existingDataPoint.filters = filters;
            existingDataPoint.dashboard = inputValues[dpIndex]; // Ensure dashboard always syncs

            updated[dpIndex] = existingDataPoint;
            return updated;
        });
    };

    const handleExhaustAverageConfirm = (confirmed) => {
        setShowExhaustAverageDialog(false);

        if (pendingExhaustAverageSelection) {
            const { dpIndex, filterIndex, value, isMainCard } = pendingExhaustAverageSelection;

            if (confirmed) {
                // User wants custom ranges - use customDateRanges (same as 90-day analysis)
                setCustomDateRanges([{ minDays: 0, maxDays: 5 }]);
            } else {
                // User doesn't want custom ranges - clear any existing ranges
                setCustomDateRanges([]);
            }

            // Apply the card selection
            setSelectedCardItems((prev) => {
                const updated = [...prev];
                const existingDataPoint = updated[dpIndex] || {
                    filters: [],
                    dashboard: inputValues[dpIndex],
                };
                const filters = [...(existingDataPoint.filters || [])];

                filters[filterIndex] = {
                    ...filters[filterIndex],
                    card: value,
                    items: [], // Clear items when using custom ranges
                    isMainCard: isMainCard,
                };
                existingDataPoint.filters = filters;
                existingDataPoint.dashboard = inputValues[dpIndex];
                updated[dpIndex] = existingDataPoint;
                return updated;
            });

            setPendingExhaustAverageSelection(null);
        }
    };

    const handleCustomDateAnalysisConfirm = (confirmed) => {
        setShowCustomDateAnalysisDialog(false);

        if (pendingCardSelection) {
            const { dpIndex, filterIndex, value, isMainCard } = pendingCardSelection;

            if (confirmed) {
                // User wants custom analysis
                setIsCustomDateAnalysis(true);
                // Initialize ranges based on analysis type
                if (customAnalysisType === "time") {
                    // Initialize with one empty time range
                    setCustomTimeRanges([{ label: '', startTime: '', endTime: '' }]);
                } else {
                    // Initialize with default date range
                    setCustomDateRanges([{ minDays: 0, maxDays: 5 }]);
                }
            } else {
                // User doesn't want custom analysis
                setIsCustomDateAnalysis(false);
                setCustomAnalysisType("date"); // Reset to default
            }

            // Apply the card selection
            setSelectedCardItems((prev) => {
                const updated = [...prev];
                const existingDataPoint = updated[dpIndex] || {
                    filters: [],
                    dashboard: inputValues[dpIndex],
                };
                const filters = [...(existingDataPoint.filters || [])];
                // If confirmed, only date/time cards (matching customAnalysisType) should be isMainCard
                // Since we're setting setIsCustomDateAnalysis(true) above when confirmed, check confirmed directly
                let shouldBeMainCard = isMainCard;
                if (confirmed) {
                    if (customAnalysisType === "date") {
                        const isDateCard = value?.value === "ninetyDaysData" || value?.value === "sixtyDaysData" || value?.customQuestionInputType === "dateAnalysis";
                        shouldBeMainCard = isDateCard ? true : false;
                    } else if (customAnalysisType === "time") {
                        const isTimeCard = value?.value === "shiftData" || value?.customQuestionInputType === "timeTabRange";
                        shouldBeMainCard = isTimeCard ? true : false;
                    }
                }

                filters[filterIndex] = {
                    ...filters[filterIndex],
                    card: value,
                    items: [], // Clear items when setting as isMainCard in custom analysis mode
                    isMainCard: shouldBeMainCard,
                };
                existingDataPoint.filters = filters;
                existingDataPoint.dashboard = inputValues[dpIndex];
                updated[dpIndex] = existingDataPoint;
                return updated;
            });

            setPendingCardSelection(null);
        }
    };

    const handleOperationChange = (operationIndex, newOperation) => {
        setOperations((prev) => {
            const updated = [...prev];
            updated[operationIndex] = newOperation;
            return updated;
        });
    };

    const handleConfirm = async () => {
        const errors = [];
        const newFieldErrors = {
            title: false,
            dataPoints: [],
            customDateRanges: [],
            customTimeRanges: [],
        };

        if (dataPointCount < 1) {
            errors.push("At least one data point is required.");
        }

        for (let i = 0; i < dataPointCount; i++) {
            let dataPointError = {
                dashboard: false,
                filters: [],
            };

            if (!selectedCardItems[i]?.dashboard) {
                errors.push(`Please select a data point for Data Point ${i + 1}`);
                dataPointError.dashboard = true;
            }

            const filters = selectedCardItems[i]?.filters || [];

            filters.forEach((filter, filterIndex) => {
                let filterError = {
                    card: false,
                    items: false,
                };

                if (!filter?.card?.value) {
                    errors.push(`Please select a card for Filter ${filterIndex + 1} in Data Point ${i + 1}`);
                    filterError.card = true;
                }

                // Validate items are selected (skip validation for isMainCard when isCustomDateAnalysis is true, and for exhaustAverageData with ranges)
                if (filter.items.length === 0) {
                    const hasExhaustAverageRanges = customDateRanges && Array.isArray(customDateRanges) && customDateRanges.length > 0;
                    const isExhaustAverageCard = filter?.card?.value === OVERALL_CARDS_TYPE.EXHUST_AVARAGE_DATA;
                    const shouldSkipItemsValidation =
                        filter?.card?.isTotalCard ||
                        (isCustomDateAnalysis && filter.isMainCard) ||
                        (isExhaustAverageCard && hasExhaustAverageRanges && !isCustomDateAnalysis);

                    if (!shouldSkipItemsValidation) {
                        errors.push(`Please select at least one item for Filter ${filterIndex + 1} in Data Point ${i + 1}`);
                        filterError.items = true;
                    }
                }

                dataPointError.filters.push(filterError);
            });

            newFieldErrors.dataPoints.push(dataPointError);
        }

        // Validate custom date/time ranges when isCustomDateAnalysis is true
        if (isCustomDateAnalysis) {
            // Validate that at least one matching card is selected for each data point
            for (let i = 0; i < dataPointCount; i++) {
                const filters = selectedCardItems[i]?.filters || [];
                let hasMatchingCard = false;

                for (let j = 0; j < filters.length; j++) {
                    const filter = filters[j];
                    if (filter?.card?.value) {
                        if (customAnalysisType === "date") {
                            const isDateCard = filter.card.value === "ninetyDaysData" || filter.card.value === "sixtyDaysData" || filter.card.customQuestionInputType === "dateAnalysis";
                            if (isDateCard) hasMatchingCard = true;
                        } else if (customAnalysisType === "time") {
                            const isTimeCard = filter.card.value === "shiftData" || filter.card.customQuestionInputType === "timeTabRange";
                            if (isTimeCard) hasMatchingCard = true;
                        }
                    }
                }

                if (!hasMatchingCard) {
                    if (customAnalysisType === "date") {
                        errors.push(`At least one date analysis card (90 Days Data, 60 Days Data, or Date Analysis) must be selected for Data Point ${i + 1}.`);
                    } else if (customAnalysisType === "time") {
                        errors.push(`At least one time analysis card (Shift Data or Time Tab Range) must be selected for Data Point ${i + 1}.`);
                    }
                }
            }

            if (customAnalysisType === "date") {

                // Validate date ranges and averages (both stored in customDateRanges)
                // Allow either ranges or averages (or both) - at least one item is required
                if (!customDateRanges || customDateRanges.length === 0) {
                    errors.push("At least one custom day range or average is required.");
                    newFieldErrors.customDateRanges = [{ minDays: true, maxDays: true }];
                } else {
                    const rangeErrors = customDateRanges.map((range, index) => {
                        // Check if this is an average (has type === "average")
                        if (range.type === "average") {
                            const avgError = { title: false };
                            if (!range.title || range.title.trim() === '') {
                                errors.push(`Average Title is required for Average ${index + 1}`);
                                avgError.title = true;
                            }
                            return avgError;
                        } else {
                            // This is a regular range
                            const rangeError = { minDays: false, maxDays: false };
                            const minDaysValue = range.minDays;
                            const maxDaysValue = range.maxDays;
                            const minDays = typeof minDaysValue === 'number' ? minDaysValue : (minDaysValue === '' || minDaysValue === null || minDaysValue === undefined ? NaN : parseInt(minDaysValue, 10));
                            const maxDays = typeof maxDaysValue === 'number' ? maxDaysValue : (maxDaysValue === '' || maxDaysValue === null || maxDaysValue === undefined ? NaN : parseInt(maxDaysValue, 10));

                            if (isNaN(minDays) || minDaysValue === '' || minDaysValue === null || minDaysValue === undefined) {
                                errors.push(`Min Days is required for Range ${index + 1}`);
                                rangeError.minDays = true;
                            }

                            if (isNaN(maxDays) || maxDaysValue === '' || maxDaysValue === null || maxDaysValue === undefined) {
                                errors.push(`Max Days is required for Range ${index + 1}`);
                                rangeError.maxDays = true;
                            } else if (!rangeError.minDays && !isNaN(minDays) && minDays >= maxDays) {
                                errors.push(`Max Days must be greater than Min Days for Range ${index + 1}`);
                                rangeError.maxDays = true;
                            }

                            return rangeError;
                        }
                    });
                    newFieldErrors.customDateRanges = rangeErrors;
                }
            } else if (customAnalysisType === "time") {
                // Validate time ranges - only check if fields are empty
                if (!customTimeRanges || customTimeRanges.length === 0) {
                    errors.push("At least one custom time range is required.");
                    newFieldErrors.customTimeRanges = [{ label: true, startTime: true, endTime: true }];
                } else {
                    const rangeErrors = customTimeRanges.map((range, index) => {
                        const rangeError = { label: false, startTime: false, endTime: false };

                        if (!range.label || range.label.trim() === '') {
                            errors.push(`Range Label is required for Time Range ${index + 1}`);
                            rangeError.label = true;
                        }

                        if (!range.startTime || range.startTime.trim() === '') {
                            errors.push(`Start Time is required for Time Range ${index + 1}`);
                            rangeError.startTime = true;
                        }

                        if (!range.endTime || range.endTime.trim() === '') {
                            errors.push(`End Time is required for Time Range ${index + 1}`);
                            rangeError.endTime = true;
                        }

                        return rangeError;
                    });
                    newFieldErrors.customTimeRanges = rangeErrors;
                }
            }
        }

        // Validate exhaust average ranges (uses customDateRanges, same as 90-day analysis)
        // Check if any data point has exhaustAverageData card selected
        const hasExhaustAverageCardSelected = selectedCardItems.some((dataPoint) =>
            dataPoint?.filters?.some(filter => filter?.card?.value === OVERALL_CARDS_TYPE.EXHUST_AVARAGE_DATA)
        );

        if (hasExhaustAverageCardSelected && !isCustomDateAnalysis) {
            // Only validate if custom ranges exist (user clicked "Yes" in dialog)
            // If customDateRanges is empty/undefined, user clicked "No" and validation should be skipped
            if (customDateRanges && customDateRanges.length > 0) {
                // Validate customDateRanges for exhaust average (same validation as 90-day analysis)
                // Allow either ranges or averages (or both) - at least one item is required
                const rangeErrors = customDateRanges.map((range, index) => {
                    // Check if this is an average (has type === "average")
                    if (range.type === "average") {
                        const avgError = { title: false };
                        if (!range.title || range.title.trim() === '') {
                            errors.push(`Average Title is required for Average ${index + 1}`);
                            avgError.title = true;
                        }
                        return avgError;
                    } else {
                        // This is a regular range
                        const rangeError = { minDays: false, maxDays: false };
                        const minDaysValue = range.minDays;
                        const maxDaysValue = range.maxDays;
                        const minDays = typeof minDaysValue === 'number' ? minDaysValue : (minDaysValue === '' || minDaysValue === null || minDaysValue === undefined ? NaN : parseInt(minDaysValue, 10));
                        const maxDays = typeof maxDaysValue === 'number' ? maxDaysValue : (maxDaysValue === '' || maxDaysValue === null || maxDaysValue === undefined ? NaN : parseInt(maxDaysValue, 10));

                        if (isNaN(minDays) || minDaysValue === '' || minDaysValue === null || minDaysValue === undefined) {
                            errors.push(`Min Days is required for Exhaust Average Range ${index + 1}`);
                            rangeError.minDays = true;
                        }

                        if (isNaN(maxDays) || maxDaysValue === '' || maxDaysValue === null || maxDaysValue === undefined) {
                            errors.push(`Max Days is required for Exhaust Average Range ${index + 1}`);
                            rangeError.maxDays = true;
                        } else if (!rangeError.minDays && !isNaN(minDays) && minDays >= maxDays) {
                            errors.push(`Max Days must be greater than Min Days for Exhaust Average Range ${index + 1}`);
                            rangeError.maxDays = true;
                        }

                        return rangeError;
                    }
                });
                newFieldErrors.customDateRanges = rangeErrors;
            }
        }

        const normalizedTitle = title.trim().toLowerCase();
        const currentId = id ? String(id) : null;
        const hasDuplicateTitle = normalizedTitle
            ? existingTabOptions.some((tab) => {
                const tabTitle = (tab?.label ?? tab?.title ?? "").trim().toLowerCase();
                if (!tabTitle || tabTitle !== normalizedTitle) return false;
                const tabId = tab?._id ? String(tab._id) : null;
                if (isEditMode && currentId && tabId && tabId === currentId) return false;
                return true;
            })
            : false;

        if (!title.trim()) {
            errors.push("Title is required.");
            newFieldErrors.title = true;
        } else if (hasDuplicateTitle) {
            errors.push("Title already exists.");
            newFieldErrors.title = true;
        }

        if (errors.length > 0) {
            setErrorMessages(errors);
            setErrorPopover({ open: true });
            setFieldErrors(newFieldErrors);
            setTitleError(newFieldErrors.title);
            return;
        }

        setIsSaving(true);
        try {
            // Normalize ranges before saving based on analysis type
            let normalizedRanges = undefined;
            if (isCustomDateAnalysis) {
                if (customAnalysisType === "date") {
                    // Normalize customDateRanges (ensure all values are numbers, not empty strings)
                    // Preserve averages (type === "average") as-is
                    normalizedRanges = customDateRanges
                        ? customDateRanges.map(item => {
                            // If it's an average, keep it as-is
                            if (item.type === "average") {
                                return { type: "average", title: item.title || "" };
                            }
                            // Otherwise, normalize the range
                            return {
                                minDays: typeof item.minDays === 'number' ? item.minDays : (parseInt(item.minDays, 10) || 0),
                                maxDays: typeof item.maxDays === 'number' ? item.maxDays : (parseInt(item.maxDays, 10) || (typeof item.minDays === 'number' ? item.minDays : 0) + 1)
                            };
                        })
                        : undefined;
                } else if (customAnalysisType === "time") {
                    // Use customTimeRanges as-is (they're already in the correct format)
                    normalizedRanges = customTimeRanges && customTimeRanges.length > 0 ? customTimeRanges : undefined;
                }
            }

            // Check if exhaustAverageData card is selected (uses customDateRanges, same as 90-day analysis)
            const hasExhaustAverageCardSelected = selectedCardItems.some((dataPoint) =>
                dataPoint?.filters?.some(filter => filter?.card?.value === OVERALL_CARDS_TYPE.EXHUST_AVARAGE_DATA)
            );

            // If exhaust average card is selected but not in custom date analysis mode, normalize customDateRanges for exhaust average
            if (hasExhaustAverageCardSelected && !isCustomDateAnalysis) {
                if (customDateRanges && Array.isArray(customDateRanges) && customDateRanges.length > 0) {
                    // Normalize customDateRanges for exhaust average (same as 90-day analysis)
                    normalizedRanges = customDateRanges.map(item => {
                        // If it's an average, keep it as-is
                        if (item.type === "average") {
                            return { type: "average", title: item.title || "" };
                        }
                        // Otherwise, normalize the range
                        return {
                            minDays: typeof item.minDays === 'number' ? item.minDays : (parseInt(item.minDays, 10) || 0),
                            maxDays: typeof item.maxDays === 'number' ? item.maxDays : (parseInt(item.maxDays, 10) || (typeof item.minDays === 'number' ? item.minDays : 0) + 1)
                        };
                    });
                }
            }

            // Prepare filters with labels - add label to each filter group
            const filtersWithLabels = selectedCardItems.map((filterGroup, index) => {
                const label = dataPointLabels[index];
                const finalLabel = (label && label.trim())
                    ? label.trim()
                    : (inputValues[index] ? formatDataPointName(inputValues[index]) : "");

                return {
                    ...filterGroup,
                    label: finalLabel
                };
            });

            let res = await createCustomTab({
                page,
                filters: filtersWithLabels,
                title: title.trim(),
                description: description.trim(),
                aiDescription: aiDescription.trim(),
                id,
                isEditMode,
                type: CUSTOM_TAB_TYPE.combineTab,
                operations: dataPointCount > 1 ? operations : [], // Only include operations if there are multiple data points
                isCustomDateAnalysis: isCustomDateAnalysis,
                customAnalysisType: isCustomDateAnalysis ? customAnalysisType : undefined,
                customDateRanges: normalizedRanges
            });

            if (res && res.status === 400) {
                if (!title.trim()) {
                    errors.push("Title is required.");
                } else if (hasDuplicateTitle) {
                    errors.push("Title already exists.");
                } else {
                    errors.push("Title already exists, Please try another title");
                }
                setErrorMessages(errors);
                setErrorPopover({ open: true });
                setTitleError(true);
                return;
            } else if (res) {
                dispatch({
                    type: ADD_NOTIFICATION,
                    payload: {
                        type: "success",
                        label: "Custom tab added successfully!",
                        id: "customTabAdded",
                    },
                });
            }
            // Force a consistent refresh pulse for every save:
            // pages currently refetch when this flag becomes true.
            dispatch(setIsCustomTabAdded(true));
            window.setTimeout(() => {
                dispatch(setIsCustomTabAdded(false));
            }, 0);
            handleClose();
        } catch (error) {
            console.error('Error saving custom tab:', error);
            dispatch({
                type: ADD_NOTIFICATION,
                payload: {
                    type: "error",
                    label: "Failed to save custom tab. Please try again.",
                    id: "customTabError",
                },
            });
        } finally {
            setIsSaving(false);
        }
    };

    const addMoreCardItem = (dpIndex) => {
        setSelectedCardItems((prev) => {
            const updated = [...prev];

            // Ensure existing data point
            const existingDataPoint = updated[dpIndex] || { filters: [], dashboard: inputValues[dpIndex] };

            existingDataPoint.filters = [...(existingDataPoint.filters || [])];

            // Add new filter
            existingDataPoint.filters.push({ card: { value: "", label: "", questionId: null }, items: [], isMainCard: false });

            // After adding, update isMainCard logic
            // In custom analysis mode, only cards matching customAnalysisType are marked as isMainCard
            // Otherwise, set isMainCard only for last filter of last DP
            updated.forEach((dp, dpI) => {
                if (!dp) return;
                dp.filters = dp.filters.map((filter, filterI) => {
                    let shouldBeMainCard = dpI === dataPointCount - 1 && filterI === (dp.filters.length - 1);

                    if (isCustomDateAnalysis && filter.card?.value) {
                        if (customAnalysisType === "date") {
                            const isDateCard = filter.card.value === "ninetyDaysData" || filter.card.value === "sixtyDaysData" || filter.card.customQuestionInputType === "dateAnalysis";
                            shouldBeMainCard = isDateCard ? true : false;
                        } else if (customAnalysisType === "time") {
                            const isTimeCard = filter.card.value === "shiftData" || filter.card.customQuestionInputType === "timeTabRange";
                            shouldBeMainCard = isTimeCard ? true : false;
                        }
                    }

                    return { ...filter, isMainCard: shouldBeMainCard };
                });
            });

            updated[dpIndex] = existingDataPoint;
            return updated;
        });
    };

    const handleRemoveFilter = (cardIndex, filterIndex) => {
        const updated = [...selectedCardItems];
        updated[cardIndex].filters = updated[cardIndex].filters.filter((_, i) => i !== filterIndex);
        setSelectedCardItems(updated); // Assuming you're using useState
    };

    const isAnyDataPointLoading = () => {
        return initialLoading || cardItemData.some(data => data?.loading);
    };

    const handleTitleChange = (e) => {
        setTitle(e.target.value);
        if (titleError) {
            setTitleError(false);
        }
    };

    // AI Description verification handler
    const handleVerifyAIDescription = async () => {
        if (!description || !description.trim()) {
            return;
        }

        try {
            setIsVerifyingAI(true);
            setAiDescriptionError(null);

            const result = await aiService.verifyAIDescription(
                description,
                title,
                'combineTab'
            );

            // Save the AI description
            setAiDescription(result.aiUnderstanding);

        } catch (error) {
            console.error('Error verifying AI description:', error);
            setAiDescriptionError(error.message || 'Failed to verify AI description');
        } finally {
            setIsVerifyingAI(false);
        }
    };

    return (
        <>
            <ErrorPopover
                open={errorPopover.open}
                onClose={() => setErrorPopover({ open: false })}
                errorMessages={errorMessages}
            />

            {/* Exhaust Average Custom Ranges Confirmation Dialog */}
            <Dialog
                open={showExhaustAverageDialog}
                onClose={() => setShowExhaustAverageDialog(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Custom Exhaust Average Ranges
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1" gutterBottom>
                        Would you like to add custom day ranges for this exhaust average data?
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        If yes, you can define custom day ranges for exhaust average data. The ranges will be displayed at the bottom of the dialog.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleExhaustAverageConfirm(false)}>
                        No
                    </Button>
                    <Button onClick={() => handleExhaustAverageConfirm(true)} variant="contained" color="primary">
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Custom Date/Time Analysis Confirmation Dialog */}
            <Dialog
                open={showCustomDateAnalysisDialog}
                onClose={() => setShowCustomDateAnalysisDialog(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    {customAnalysisType === "time" ? "Custom Time Analysis Tab" : "Custom Date Analysis Tab"}
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1" gutterBottom>
                        Do you want to custom create a {customAnalysisType === "time" ? "time" : "date"} analysis tab?
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        {customAnalysisType === "time" ? (
                            <>
                                If yes, you can define custom time ranges to combine data across selected time categories.
                                At least one time analysis card must be selected across all data points, and time analysis cards will be marked as main cards.
                            </>
                        ) : (
                            <>
                                If yes, you can define custom day ranges to combine data across selected categories.
                                At least one date analysis card must be selected across all data points, and date analysis cards will be marked as main cards.
                            </>
                        )}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleCustomDateAnalysisConfirm(false)}>
                        No
                    </Button>
                    <Button onClick={() => handleCustomDateAnalysisConfirm(true)} variant="contained" color="primary">
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={true} onClose={initialLoading ? undefined : handleClose} maxWidth="md" fullWidth>
                <DialogTitle>{isEditMode ? isCreator ? 'Edit Combine Data From Separate Dashboard tabs' : 'View Combine Data From Separate Dashboard tabs' : 'Create Combine Data From Separate Dashboard tabs'}
                </DialogTitle>
                <DialogContent sx={{ pt: 2 }}>
                    {initialLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                            <LoadingBlock size={40} message="Loading custom tab data..." />
                        </Box>
                    ) : (
                        <>
                            <LabeledSelect
                                label="Number of Data Points"
                                value={dataPointCount}
                                onChange={handleCountChange}
                                options={[
                                    { label: '1', value: 1 },
                                    { label: '2', value: 2 },
                                    { label: '3', value: 3 },
                                    { label: '4', value: 4 },
                                    { label: '5', value: 5 }
                                ]}
                                error={false}
                                sx={{ mt: 2, width: 160 }}
                                size="medium"
                                disabled={!isCreator}
                            />

                            <Box display="flex" flexDirection="column" gap={2} mt={2}>
                                {inputValues.map((val, index) => (
                                    <Box key={index}>
                                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, backgroundColor: "#fafafa" }}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Data Point {index + 1}
                                            </Typography>

                                            <FormControl fullWidth sx={{ mb: 1 }} size="medium">
                                                <InputLabel>Select Data Point</InputLabel>
                                                <Select
                                                    value={val}
                                                    label="Select Data Point"
                                                    onChange={(e) => handleInputChange(index, e.target.value)}
                                                    disabled={!isCreator}
                                                >
                                                    {(() => {
                                                        const filteredBySelectedTab = validPageTypes.filter(([_, value]) => {
                                                            // If selectedTab includes 'overall', show both OVERALL_INCOMING and OVERALL_OUTGOING
                                                            if (selectedTab.includes(PAGE_TYPE.OVERALL)) {
                                                                if (value === CUSTOM_TAB_PAGE_TYPE.OVERALL_INCOMING || value === CUSTOM_TAB_PAGE_TYPE.OVERALL_OUTGOING) {
                                                                    return true;
                                                                }
                                                            }
                                                            return selectedTab.includes(value);
                                                        });

                                                        if (index === 0) {
                                                            // First selection - if page is OVERALL, show all filtered options; otherwise only show matching page
                                                            if (page === PAGE_TYPE.OVERALL) {
                                                                // For overall page, show all available data points from filteredBySelectedTab
                                                                return filteredBySelectedTab;
                                                            } else {
                                                                // For other pages, only show matching page
                                                                return filteredBySelectedTab.filter(([_, value]) => value === page);
                                                            }
                                                        } else {
                                                            // For all other indices, show all filteredBySelectedTab options
                                                            // Allow same data point to be selected multiple times
                                                            return filteredBySelectedTab.filter(([_, value]) => {
                                                                // If in custom analysis mode, hide ADMISSION and OVERALL_INCOMING (they don't have required cards)
                                                                if (isCustomDateAnalysis && index > 0) {
                                                                    if ((value === CUSTOM_TAB_PAGE_TYPE.ADMISSION || value === CUSTOM_TAB_PAGE_TYPE.OVERALL_INCOMING) && page === PAGE_TYPE.OVERALL) {
                                                                        return false;
                                                                    }
                                                                }
                                                                return true;
                                                            });
                                                        }
                                                    })().map(([label, value]) => {
                                                        const cleanedLabel = label.replace(/_/g, " ");
                                                        const formattedLabel =
                                                            cleanedLabel.charAt(0).toUpperCase() +
                                                            cleanedLabel.slice(1).toLowerCase();
                                                        return (
                                                            <MenuItem key={value} value={value}>
                                                                {formattedLabel}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                            </FormControl>

                                            {/* Data Point Label Input */}
                                            {val && (
                                                <TextField
                                                    label="Data Point Label"
                                                    fullWidth
                                                    value={dataPointLabels[index] || ""}
                                                    onChange={(e) => {
                                                        const updated = [...dataPointLabels];
                                                        updated[index] = e.target.value;
                                                        setDataPointLabels(updated);
                                                    }}
                                                    disabled={!isCreator}
                                                    sx={{ mb: 1, mt: 1 }}
                                                    placeholder={formatDataPointName(val)}
                                                />
                                            )}

                                            {cardItemData[index]?.loading ? (
                                                <LoadingBlock size={30} message="Loading card & item options..." />
                                            ) : (
                                                <>
                                                    <Divider sx={{ my: 2 }} />

                                                    {(selectedCardItems[index]?.filters || []).map((filter, filterIndex) => {
                                                        // Use the filter's isMainCard property (it's already set correctly when card is selected)
                                                        const filterIsMainCard = filter.isMainCard || false;
                                                        // Check if this card should be highlighted (only when isMainCard is true, isCustomDateAnalysis is true, AND card is selected)
                                                        const shouldHighlight = false; // isCustomDateAnalysis && filterIsMainCard && filter?.card?.value;

                                                        return (
                                                            <Box key={filterIndex} display="flex" gap={2} flexDirection={{ xs: "column", sm: "row" }} mt={2}>
                                                                <Box sx={{
                                                                    flex: 1,
                                                                    ...(shouldHighlight && {
                                                                        '& .MuiFormControl-root .MuiOutlinedInput-root': {
                                                                            border: '2px solid #1976d2 !important',
                                                                            '&:hover': {
                                                                                border: '2px solid #1976d2 !important',
                                                                            },
                                                                            '&.Mui-focused': {
                                                                                border: '2px solid #1976d2 !important',
                                                                            },
                                                                        },
                                                                    })
                                                                }}>
                                                                    <LabeledSelect
                                                                        label="Select Card"
                                                                        value={filter?.card?.value || ""}
                                                                        disabled={!isCreator}
                                                                        onChange={(ele) => {
                                                                            const selectedValue = ele.target.value;
                                                                            const selectedCard = cardItemData[index]?.cards?.find((card) => card.value === selectedValue);
                                                                            // Calculate isMainCard: if isCustomDateAnalysis is false, use default logic (last filter of last data point)
                                                                            const defaultIsMainCard = !isCustomDateAnalysis && (index === dataPointCount - 1 && filterIndex === (selectedCardItems[index]?.filters.length - 1));
                                                                            handleCardItemChange(index, filterIndex, "card", selectedCard, defaultIsMainCard);
                                                                        }}
                                                                        options={(cardItemData[index]?.cards || [])
                                                                            ?.filter((card) => {
                                                                                // Don't show cards already selected in this data point
                                                                                const selectedValues = (selectedCardItems[index]?.filters || [])
                                                                                    .filter((_, i) => i !== filterIndex)
                                                                                    .map((f) => f.card?.value);
                                                                                if (selectedValues.includes(card.value)) {
                                                                                    return false;
                                                                                }

                                                                                // Hide insuranceData card if exhaustInsuranceData or exhaustAverageData is selected in any filter
                                                                                const hasExhaustCard = selectedCardItems.some((dataPoint) =>
                                                                                    dataPoint?.filters?.some(filter =>
                                                                                        filter?.card?.value === OVERALL_CARDS_TYPE.EXHUAST_INSURANCE_DATA ||
                                                                                        filter?.card?.value === OVERALL_CARDS_TYPE.EXHUST_AVARAGE_DATA
                                                                                    )
                                                                                );
                                                                                if (hasExhaustCard && card.value === OVERALL_CARDS_TYPE.INSURANCE_DATA) {
                                                                                    return false;
                                                                                }

                                                                                return true;
                                                                            })
                                                                            ?.map(card => ({ label: card.label, value: card.value })) || []}
                                                                        error={fieldErrors?.dataPoints[index]?.filters[filterIndex]?.card}
                                                                        size="medium"
                                                                    />
                                                                </Box>
                                                                {!filter?.card?.isTotalCard && filter?.card?.value && !(isCustomDateAnalysis && filter.isMainCard) && (
                                                                    cardItemData[index]?.loading ? (
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 40 }}>
                                                                            <LoadingBlock size={20} message="Loading items..." />
                                                                        </Box>
                                                                    ) : (
                                                                        <ItemAutocomplete
                                                                            disabled={!isCreator}
                                                                            label="Select Items"
                                                                            value={Array.isArray(filter?.items) ? filter.items : []}
                                                                            onChange={(e, newValue) => {
                                                                                // Handled inside the component already — you can skip if you're using handleCardItemChange there
                                                                            }}
                                                                            error={fieldErrors?.dataPoints[index]?.filters[filterIndex]?.items}
                                                                            helperText=""
                                                                            cardItemData={cardItemData}
                                                                            index={index}
                                                                            filterIndex={filterIndex}
                                                                            filter={filter}
                                                                            isMainCard={filterIsMainCard}
                                                                            handleCardItemChange={handleCardItemChange}
                                                                            fieldErrors={fieldErrors}
                                                                        />
                                                                    )
                                                                )}

                                                                {selectedCardItems[index]?.filters.length > 1 && (
                                                                    <IconButton
                                                                        disabled={!isCreator}
                                                                        aria-label="Remove Filter"
                                                                        color="error"
                                                                        size="small"
                                                                        onClick={() => handleRemoveFilter(index, filterIndex)}
                                                                        sx={{
                                                                            mt: 1,
                                                                            width: 36,
                                                                            height: 36,
                                                                            padding: 1,
                                                                            alignSelf: "flex-start"
                                                                        }}
                                                                    >
                                                                        <DeleteIcon fontSize="small" />
                                                                    </IconButton>
                                                                )}
                                                            </Box>
                                                        )
                                                    })}

                                                    <Box mt={1}>
                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            onClick={() => addMoreCardItem(index)}
                                                            sx={{ mt: 1 }}
                                                            disabled={!isCreator}
                                                        >
                                                            Add Filter
                                                        </Button>
                                                    </Box>
                                                </>
                                            )}
                                        </Paper>

                                        {/* Show plus/minus/average button if there's a next data point and we have operations */}
                                        {index < dataPointCount - 1 && dataPointCount > 1 && (
                                            <Box display="flex" justifyContent="center" alignItems="center" my={2} gap={2}>
                                                <Button
                                                    variant={operations[index] === 'plus' ? "contained" : "outlined"}
                                                    size="large"
                                                    onClick={() => handleOperationChange(index, 'plus')}
                                                    disabled={!isCreator}
                                                    sx={{
                                                        minWidth: '80px',
                                                        height: '48px',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        backgroundColor: operations[index] === 'plus' ? '#4caf50' : 'transparent',
                                                        color: operations[index] === 'plus' ? 'white' : '#4caf50',
                                                        borderColor: '#4caf50',
                                                        borderWidth: operations[index] === 'plus' ? '2px' : '1px',
                                                        boxShadow: operations[index] === 'plus' ? '0 4px 8px rgba(76, 175, 80, 0.3), 0 2px 4px rgba(76, 175, 80, 0.2)' : 'none',
                                                        transform: operations[index] === 'plus' ? 'translateY(-2px)' : 'translateY(0)',
                                                        transition: 'all 0.2s ease-in-out',
                                                        position: 'relative',
                                                        '&:hover': {
                                                            backgroundColor: operations[index] === 'plus' ? '#45a049' : '#e8f5e8',
                                                            boxShadow: operations[index] === 'plus' ? '0 6px 12px rgba(76, 175, 80, 0.4), 0 3px 6px rgba(76, 175, 80, 0.3)' : '0 2px 4px rgba(76, 175, 80, 0.2)',
                                                            transform: operations[index] === 'plus' ? 'translateY(-3px)' : 'translateY(-1px)',
                                                        },
                                                        '&:disabled': {
                                                            backgroundColor: '#cccccc',
                                                            color: '#666666',
                                                            borderColor: '#cccccc',
                                                            boxShadow: 'none',
                                                            transform: 'translateY(0)',
                                                        },
                                                        '&::before': operations[index] === 'plus' ? {
                                                            content: '""',
                                                            position: 'absolute',
                                                            top: '-4px',
                                                            left: '-4px',
                                                            right: '-4px',
                                                            bottom: '-4px',
                                                            border: '2px solid #4caf50',
                                                            borderRadius: '8px',
                                                            opacity: 0.3,
                                                            zIndex: -1,
                                                        } : {}
                                                    }}
                                                >
                                                    <AddIcon />
                                                </Button>

                                                <Button
                                                    variant={operations[index] === 'minus' ? "contained" : "outlined"}
                                                    size="large"
                                                    onClick={() => handleOperationChange(index, 'minus')}
                                                    disabled={!isCreator}
                                                    sx={{
                                                        minWidth: '80px',
                                                        height: '48px',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        backgroundColor: operations[index] === 'minus' ? '#f44336' : 'transparent',
                                                        color: operations[index] === 'minus' ? 'white' : '#f44336',
                                                        borderColor: '#f44336',
                                                        borderWidth: operations[index] === 'minus' ? '2px' : '1px',
                                                        boxShadow: operations[index] === 'minus' ? '0 4px 8px rgba(244, 67, 54, 0.3), 0 2px 4px rgba(244, 67, 54, 0.2)' : 'none',
                                                        transform: operations[index] === 'minus' ? 'translateY(-2px)' : 'translateY(0)',
                                                        transition: 'all 0.2s ease-in-out',
                                                        position: 'relative',
                                                        '&:hover': {
                                                            backgroundColor: operations[index] === 'minus' ? '#da190b' : '#ffebee',
                                                            boxShadow: operations[index] === 'minus' ? '0 6px 12px rgba(244, 67, 54, 0.4), 0 3px 6px rgba(244, 67, 54, 0.3)' : '0 2px 4px rgba(244, 67, 54, 0.2)',
                                                            transform: operations[index] === 'minus' ? 'translateY(-3px)' : 'translateY(-1px)',
                                                        },
                                                        '&:disabled': {
                                                            backgroundColor: '#cccccc',
                                                            color: '#666666',
                                                            borderColor: '#cccccc',
                                                            boxShadow: 'none',
                                                            transform: 'translateY(0)',
                                                        },
                                                        '&::before': operations[index] === 'minus' ? {
                                                            content: '""',
                                                            position: 'absolute',
                                                            top: '-4px',
                                                            left: '-4px',
                                                            right: '-4px',
                                                            bottom: '-4px',
                                                            border: '2px solid #f44336',
                                                            borderRadius: '8px',
                                                            opacity: 0.3,
                                                            zIndex: -1,
                                                        } : {}
                                                    }}
                                                >
                                                    <RemoveIcon />
                                                </Button>

                                                <Button
                                                    variant={operations[index] === 'average' ? "contained" : "outlined"}
                                                    size="large"
                                                    onClick={() => handleOperationChange(index, 'average')}
                                                    disabled={!isCreator}
                                                    sx={{
                                                        minWidth: '80px',
                                                        height: '48px',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        backgroundColor: operations[index] === 'average' ? '#2196f3' : 'transparent',
                                                        color: operations[index] === 'average' ? 'white' : '#2196f3',
                                                        borderColor: '#2196f3',
                                                        borderWidth: operations[index] === 'average' ? '2px' : '1px',
                                                        boxShadow: operations[index] === 'average' ? '0 4px 8px rgba(33, 150, 243, 0.3), 0 2px 4px rgba(33, 150, 243, 0.2)' : 'none',
                                                        transform: operations[index] === 'average' ? 'translateY(-2px)' : 'translateY(0)',
                                                        transition: 'all 0.2s ease-in-out',
                                                        position: 'relative',
                                                        '&:hover': {
                                                            backgroundColor: operations[index] === 'average' ? '#1976d2' : '#e3f2fd',
                                                            boxShadow: operations[index] === 'average' ? '0 6px 12px rgba(33, 150, 243, 0.4), 0 3px 6px rgba(33, 150, 243, 0.3)' : '0 2px 4px rgba(33, 150, 243, 0.2)',
                                                            transform: operations[index] === 'average' ? 'translateY(-3px)' : 'translateY(-1px)',
                                                        },
                                                        '&:disabled': {
                                                            backgroundColor: '#cccccc',
                                                            color: '#666666',
                                                            borderColor: '#cccccc',
                                                            boxShadow: 'none',
                                                            transform: 'translateY(0)',
                                                        },
                                                        '&::before': operations[index] === 'average' ? {
                                                            content: '""',
                                                            position: 'absolute',
                                                            top: '-4px',
                                                            left: '-4px',
                                                            right: '-4px',
                                                            bottom: '-4px',
                                                            border: '2px solid #2196f3',
                                                            borderRadius: '8px',
                                                            opacity: 0.3,
                                                            zIndex: -1,
                                                        } : {}
                                                    }}
                                                >
                                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                                        <Typography sx={{ fontSize: '14px', fontWeight: 'bold' }}>AVG</Typography>
                                                    </Box>

                                                </Button>
                                            </Box>
                                        )}
                                    </Box>
                                ))}
                            </Box>

                            {/* Custom Date Ranges UI - only show when in custom date analysis mode */}
                            {isCustomDateAnalysis && customAnalysisType === "date" && (
                                <Box mt={3} sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                    <Typography variant="subtitle2" gutterBottom>
                                        Custom Day Ranges
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
                                        Define custom day ranges to combine data across selected categories
                                    </Typography>
                                    {customDateRanges.map((item, itemIndex) => {
                                        // Check if this is an average
                                        if (item.type === "average") {
                                            const avgError = fieldErrors?.customDateRanges?.[itemIndex] || { title: false };
                                            return (
                                                <Box key={itemIndex} display="flex" gap={2} alignItems="center" mb={2}>
                                                    <TextField
                                                        label="Average Title"
                                                        type="text"
                                                        required
                                                        fullWidth
                                                        value={item.title || ''}
                                                        onChange={(e) => {
                                                            const newRanges = [...customDateRanges];
                                                            newRanges[itemIndex].title = e.target.value;
                                                            setCustomDateRanges(newRanges);
                                                            // Clear error when user starts typing
                                                            if (fieldErrors?.customDateRanges?.[itemIndex]?.title) {
                                                                setFieldErrors(prev => ({
                                                                    ...prev,
                                                                    customDateRanges: (prev.customDateRanges || []).map((err, idx) =>
                                                                        idx === itemIndex ? { ...err, title: false } : err
                                                                    )
                                                                }));
                                                            }
                                                        }}
                                                        disabled={!isCreator}
                                                        size="small"
                                                        error={avgError.title}
                                                        helperText={avgError.title ? "Required" : ""}
                                                        sx={{ width: 280 }}
                                                    />
                                                    <IconButton
                                                        disabled={!isCreator}
                                                        size="small"
                                                        onClick={() => {
                                                            setCustomDateRanges(customDateRanges.filter((_, i) => i !== itemIndex));
                                                        }}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            );
                                        } else {
                                            // This is a regular range
                                            const rangeError = fieldErrors?.customDateRanges?.[itemIndex] || { minDays: false, maxDays: false };
                                            return (
                                                <Box key={itemIndex} display="flex" gap={2} alignItems="center" mb={2}>
                                                    <TextField
                                                        label="Min Days"
                                                        type="number"
                                                        required
                                                        value={item.minDays === undefined || item.minDays === null || item.minDays === '' ? '' : item.minDays}
                                                        onChange={(e) => {
                                                            const newRanges = [...customDateRanges];
                                                            const value = e.target.value;
                                                            if (value === '' || value === '-') {
                                                                newRanges[itemIndex].minDays = '';
                                                            } else {
                                                                const numValue = parseInt(value, 10);
                                                                if (!isNaN(numValue) && numValue >= 0) {
                                                                    newRanges[itemIndex].minDays = numValue;
                                                                }
                                                            }
                                                            setCustomDateRanges(newRanges);
                                                            // Clear error when user starts typing
                                                            if (fieldErrors?.customDateRanges?.[itemIndex]?.minDays) {
                                                                setFieldErrors(prev => ({
                                                                    ...prev,
                                                                    customDateRanges: (prev.customDateRanges || []).map((err, idx) =>
                                                                        idx === itemIndex ? { ...err, minDays: false } : err
                                                                    )
                                                                }));
                                                            }
                                                        }}
                                                        onBlur={(e) => {
                                                            // Don't auto-fill - let validation handle empty values
                                                            // User must explicitly enter a value
                                                        }}
                                                        disabled={!isCreator}
                                                        size="small"
                                                        sx={{ width: 120 }}
                                                        inputProps={{ min: 0 }}
                                                        error={rangeError.minDays}
                                                        helperText={rangeError.minDays ? "Required" : ""}
                                                    />
                                                    <Typography>-</Typography>
                                                    <TextField
                                                        label="Max Days"
                                                        type="number"
                                                        required
                                                        value={item.maxDays === undefined || item.maxDays === null || item.maxDays === '' ? '' : item.maxDays}
                                                        onChange={(e) => {
                                                            const newRanges = [...customDateRanges];
                                                            const value = e.target.value;
                                                            if (value === '' || value === '-') {
                                                                newRanges[itemIndex].maxDays = '';
                                                            } else {
                                                                const numValue = parseInt(value, 10);
                                                                // Allow any number to be entered during typing (validation will catch invalid values on submit)
                                                                // Store as number if valid, otherwise as empty string to allow clearing
                                                                newRanges[itemIndex].maxDays = !isNaN(numValue) ? numValue : '';
                                                            }
                                                            setCustomDateRanges(newRanges);
                                                            // Clear error when user starts typing
                                                            if (fieldErrors?.customDateRanges?.[itemIndex]?.maxDays) {
                                                                setFieldErrors(prev => ({
                                                                    ...prev,
                                                                    customDateRanges: (prev.customDateRanges || []).map((err, idx) =>
                                                                        idx === itemIndex ? { ...err, maxDays: false } : err
                                                                    )
                                                                }));
                                                            }
                                                        }}
                                                        onBlur={(e) => {
                                                            // Don't auto-fill - let validation handle empty values
                                                            // User must explicitly enter a value
                                                        }}
                                                        disabled={!isCreator}
                                                        size="small"
                                                        sx={{ width: 120 }}
                                                        inputProps={{ min: typeof item.minDays === 'number' ? item.minDays : 0 }}
                                                        error={rangeError.maxDays}
                                                        helperText={rangeError.maxDays ? "Required and must be greater than Min Days" : ""}
                                                    />
                                                    {customDateRanges.length > 1 && (
                                                        <IconButton
                                                            disabled={!isCreator}
                                                            size="small"
                                                            onClick={() => {
                                                                setCustomDateRanges(customDateRanges.filter((_, i) => i !== itemIndex));
                                                            }}
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    )}
                                                </Box>
                                            );
                                        }
                                    })}
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => {
                                            const lastRange = customDateRanges[customDateRanges.length - 1];
                                            setCustomDateRanges([
                                                ...customDateRanges,
                                                { minDays: (lastRange?.maxDays || 0) + 1, maxDays: (lastRange?.maxDays || 0) + 6 }
                                            ]);
                                        }}
                                        disabled={!isCreator}
                                        startIcon={<AddIcon />}
                                    >
                                        Add Range
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        sx={{ ml: 2 }}
                                        onClick={() => {
                                            setCustomDateRanges([
                                                ...customDateRanges,
                                                { type: "average", title: "" }
                                            ]);
                                        }}
                                        disabled={!isCreator || customDateRanges.some((item) => item.type === "average")}
                                        startIcon={<AddIcon />}
                                    >
                                        Add Average
                                    </Button>
                                </Box>
                            )}

                            {/* Custom Time Ranges UI - only show when in custom time analysis mode */}
                            {isCustomDateAnalysis && customAnalysisType === "time" && (
                                <Box mt={3} sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                    <Typography variant="subtitle2" gutterBottom>
                                        Custom Time Ranges
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
                                        Define custom time ranges to combine data across selected categories
                                    </Typography>
                                    {customTimeRanges.map((range, rangeIndex) => {
                                        const rangeError = fieldErrors?.customTimeRanges?.[rangeIndex] || { label: false, startTime: false, endTime: false };
                                        const formatTime = (time) => {
                                            if (!time) return '';
                                            const hour = parseInt(time.split(':')[0]);
                                            const minute = time.split(':')[1];
                                            const ampm = hour >= 12 ? 'PM' : 'AM';
                                            const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
                                            return `${displayHour}:${minute} ${ampm}`;
                                        };
                                        return (
                                            <Box key={rangeIndex} sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                                                <Grid container spacing={2} alignItems="center">
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            label="Range Label"
                                                            fullWidth
                                                            size="small"
                                                            required
                                                            value={range.label || ''}
                                                            onChange={(e) => {
                                                                const newRanges = [...customTimeRanges];
                                                                newRanges[rangeIndex].label = e.target.value;
                                                                setCustomTimeRanges(newRanges);
                                                                // Clear error when user starts typing
                                                                if (fieldErrors?.customTimeRanges?.[rangeIndex]?.label) {
                                                                    setFieldErrors(prev => ({
                                                                        ...prev,
                                                                        customTimeRanges: (prev.customTimeRanges || []).map((err, idx) =>
                                                                            idx === rangeIndex ? { ...err, label: false } : err
                                                                        )
                                                                    }));
                                                                }
                                                            }}
                                                            disabled={!isCreator}
                                                            error={rangeError.label}
                                                            helperText={rangeError.label ? "Required" : ""}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            label="Start Time"
                                                            type="time"
                                                            fullWidth
                                                            size="small"
                                                            required
                                                            value={range.startTime || ''}
                                                            onChange={(e) => {
                                                                const newRanges = [...customTimeRanges];
                                                                newRanges[rangeIndex].startTime = e.target.value;
                                                                setCustomTimeRanges(newRanges);
                                                                // Clear error when user starts typing
                                                                if (fieldErrors?.customTimeRanges?.[rangeIndex]?.startTime) {
                                                                    setFieldErrors(prev => ({
                                                                        ...prev,
                                                                        customTimeRanges: (prev.customTimeRanges || []).map((err, idx) =>
                                                                            idx === rangeIndex ? { ...err, startTime: false } : err
                                                                        )
                                                                    }));
                                                                }
                                                            }}
                                                            InputLabelProps={{ shrink: true }}
                                                            disabled={!isCreator}
                                                            error={rangeError.startTime}
                                                            helperText={rangeError.startTime ? "Required" : ""}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={3}>
                                                        <TextField
                                                            label="End Time"
                                                            type="time"
                                                            fullWidth
                                                            size="small"
                                                            required
                                                            value={range.endTime || ''}
                                                            onChange={(e) => {
                                                                const newRanges = [...customTimeRanges];
                                                                newRanges[rangeIndex].endTime = e.target.value;
                                                                setCustomTimeRanges(newRanges);
                                                                // Clear error when user starts typing
                                                                if (fieldErrors?.customTimeRanges?.[rangeIndex]?.endTime) {
                                                                    setFieldErrors(prev => ({
                                                                        ...prev,
                                                                        customTimeRanges: (prev.customTimeRanges || []).map((err, idx) =>
                                                                            idx === rangeIndex ? { ...err, endTime: false } : err
                                                                        )
                                                                    }));
                                                                }
                                                            }}
                                                            InputLabelProps={{ shrink: true }}
                                                            disabled={!isCreator}
                                                            error={rangeError.endTime}
                                                            helperText={rangeError.endTime ? "Required and must be after Start Time" : ""}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <Typography variant="body2" color="textSecondary">
                                                            {range.startTime && range.endTime ? `${formatTime(range.startTime)} - ${formatTime(range.endTime)}` : ''}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={1}>
                                                        {customTimeRanges.length > 1 && (
                                                            <IconButton
                                                                disabled={!isCreator}
                                                                size="small"
                                                                onClick={() => {
                                                                    setCustomTimeRanges(customTimeRanges.filter((_, i) => i !== rangeIndex));
                                                                }}
                                                            >
                                                                <DeleteIcon fontSize="small" />
                                                            </IconButton>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        );
                                    })}
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => {
                                            setCustomTimeRanges([
                                                ...customTimeRanges,
                                                { label: '', startTime: '', endTime: '' }
                                            ]);
                                        }}
                                        disabled={!isCreator}
                                        startIcon={<AddIcon />}
                                    >
                                        Add Range
                                    </Button>
                                </Box>
                            )}

                            {/* Exhaust Average Custom Ranges UI - show at bottom when exhaustAverageData card is selected (same as 90 days analysis) */}
                            {(() => {
                                // Check if any data point has exhaustAverageData card selected
                                const hasExhaustAverageCard = selectedCardItems.some((dataPoint) => {
                                    return dataPoint?.filters?.some(filter =>
                                        filter?.card?.value === OVERALL_CARDS_TYPE.EXHUST_AVARAGE_DATA
                                    );
                                });

                                if (!hasExhaustAverageCard || isCustomDateAnalysis) return null;

                                // Only show if custom ranges exist (user clicked "Yes" in dialog)
                                const ranges = customDateRanges || [];
                                if (!ranges || ranges.length === 0) return null;

                                return (
                                    <Box mt={3} sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                        <Typography variant="subtitle2" gutterBottom>
                                            Custom Exhaust Average Day Ranges
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
                                            Define custom day ranges for exhaust average data. At least one range is required.
                                        </Typography>

                                        {ranges.map((range, rangeIndex) => {
                                            const rangeError = fieldErrors?.customDateRanges?.[rangeIndex] || { minDays: false, maxDays: false };
                                            return (
                                                <Box key={rangeIndex} display="flex" gap={2} alignItems="center" mb={2}>
                                                    <TextField
                                                        label="Min Days"
                                                        type="number"
                                                        required
                                                        value={range.minDays === undefined || range.minDays === null || range.minDays === '' ? '' : range.minDays}
                                                        onChange={(e) => {
                                                            const newRanges = [...ranges];
                                                            const value = e.target.value;
                                                            if (value === '' || value === '-') {
                                                                newRanges[rangeIndex].minDays = '';
                                                            } else {
                                                                const numValue = parseInt(value, 10);
                                                                if (!isNaN(numValue) && numValue >= 0) {
                                                                    newRanges[rangeIndex].minDays = numValue;
                                                                }
                                                            }
                                                            setCustomDateRanges(newRanges);
                                                            // Clear error when user starts typing
                                                            if (fieldErrors?.customDateRanges?.[rangeIndex]?.minDays) {
                                                                setFieldErrors(prev => ({
                                                                    ...prev,
                                                                    customDateRanges: (prev.customDateRanges || []).map((err, idx) =>
                                                                        idx === rangeIndex ? { ...err, minDays: false } : err
                                                                    )
                                                                }));
                                                            }
                                                        }}
                                                        disabled={!isCreator}
                                                        size="small"
                                                        sx={{ width: 120 }}
                                                        inputProps={{ min: 0 }}
                                                        error={rangeError.minDays}
                                                        helperText={rangeError.minDays ? "Required" : ""}
                                                    />
                                                    <Typography>-</Typography>
                                                    <TextField
                                                        label="Max Days"
                                                        type="number"
                                                        required
                                                        value={range.maxDays === undefined || range.maxDays === null || range.maxDays === '' ? '' : range.maxDays}
                                                        onChange={(e) => {
                                                            const newRanges = [...ranges];
                                                            const value = e.target.value;
                                                            if (value === '' || value === '-') {
                                                                newRanges[rangeIndex].maxDays = '';
                                                            } else {
                                                                const numValue = parseInt(value, 10);
                                                                newRanges[rangeIndex].maxDays = !isNaN(numValue) ? numValue : '';
                                                            }
                                                            setCustomDateRanges(newRanges);
                                                            // Clear error when user starts typing
                                                            if (fieldErrors?.customDateRanges?.[rangeIndex]?.maxDays) {
                                                                setFieldErrors(prev => ({
                                                                    ...prev,
                                                                    customDateRanges: (prev.customDateRanges || []).map((err, idx) =>
                                                                        idx === rangeIndex ? { ...err, maxDays: false } : err
                                                                    )
                                                                }));
                                                            }
                                                        }}
                                                        disabled={!isCreator}
                                                        size="small"
                                                        sx={{ width: 120 }}
                                                        inputProps={{ min: typeof range.minDays === 'number' ? range.minDays : 0 }}
                                                        error={rangeError.maxDays}
                                                        helperText={rangeError.maxDays ? "Required and must be greater than Min Days" : ""}
                                                    />
                                                    {ranges.length > 1 && (
                                                        <IconButton
                                                            disabled={!isCreator}
                                                            size="small"
                                                            onClick={() => {
                                                                setCustomDateRanges(ranges.filter((_, i) => i !== rangeIndex));
                                                            }}
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    )}
                                                </Box>
                                            );
                                        })}
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={() => {
                                                const lastRange = ranges[ranges.length - 1];
                                                setCustomDateRanges([
                                                    ...ranges,
                                                    { minDays: (lastRange?.maxDays || 0) + 1, maxDays: (lastRange?.maxDays || 0) + 6 }
                                                ]);
                                            }}
                                            disabled={!isCreator}
                                            startIcon={<AddIcon />}
                                        >
                                            Add Range
                                        </Button>
                                    </Box>
                                );
                            })()}

                            <LabeledTextField
                                label="Tab Title"
                                fullWidth
                                margin="normal"
                                value={title}
                                onChange={handleTitleChange}
                                sx={{ mt: 5 }}
                                error={titleError}
                                helperText={
                                    titleError
                                        ? (errorMessages.find((msg) => /title/i.test(msg)) || "Title is required.")
                                        : ""
                                }
                                disabled={!isCreator}
                            />
                            <LabeledTextarea
                                label="Description"
                                minRows={4}
                                maxRows={8}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                placeholder="Enter description"
                                style={{
                                    width: '100%',
                                    padding: '8px 12px',
                                    fontSize: '14px',
                                    borderRadius: '4px',
                                    borderColor: '#ccc',
                                    resize: 'vertical',
                                }}
                                disabled={!isCreator}
                            />

                            {/* Confirm with AI Description Button */}
                            {description && description.trim() && (
                                <Box sx={{ mt: 1, mb: 2 }}>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={handleVerifyAIDescription}
                                        disabled={isVerifyingAI || !isCreator}
                                        startIcon={isVerifyingAI ? <CircularProgress size={16} /> : <CheckCircleIcon />}
                                    >
                                        {isVerifyingAI ? 'Verifying...' : 'Confirm with AI Description'}
                                    </Button>
                                </Box>
                            )}

                            {/* Display AI Description */}
                            {aiDescription && (
                                <Box
                                    sx={{
                                        mt: 2,
                                        p: 2,
                                        bgcolor: 'rgba(76, 175, 80, 0.08)',
                                        borderRadius: 1,
                                        border: '1px solid rgba(76, 175, 80, 0.3)'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <CheckCircleIcon sx={{ color: 'success.main', mr: 1, fontSize: 20 }} />
                                        <strong>AI Description:</strong>
                                    </Box>
                                    <Box sx={{ pl: 4, color: 'text.secondary' }}>
                                        {aiDescription}
                                    </Box>
                                </Box>
                            )}

                            {/* Display Error */}
                            {aiDescriptionError && (
                                <Box
                                    sx={{
                                        mt: 2,
                                        p: 2,
                                        bgcolor: 'rgba(211, 47, 47, 0.08)',
                                        borderRadius: 1,
                                        border: '1px solid rgba(211, 47, 47, 0.3)',
                                        color: 'error.main'
                                    }}
                                >
                                    {aiDescriptionError}
                                </Box>
                            )}
                        </>
                    )}
                </DialogContent>

                <DialogActionsRow
                    onCancel={handleClose}
                    onSave={handleConfirm}
                    loading={isSaving || initialLoading}
                    disabled={isSaving || (isEditMode && isAnyDataPointLoading()) || !isCreator}
                    cancelText="Cancel"
                    saveText="Save"
                    loadingText="Saving..."
                />

            </Dialog>
        </>
    );
};

export default AddCombineTabDialog; 